export default class PipelineStatusDomainService {
    static get ActiveId() {
        return 2;
    }
    static get InactiveId() {
        return 3;
    }
    static get ArchivedId() {
        return 1;
    }
    static getColor(statusId) {
        switch (statusId) {
            case PipelineStatusDomainService.ActiveId:
                return "success";
            case PipelineStatusDomainService.InactiveId:
                return "secondary";
            case PipelineStatusDomainService.ArchivedId:
                return "dark";
            default:
                return "";
        }
    }
}
